import "./assets/App.css";
import FlowTimer from "./components/FlowTimer";

function App() {
  return (
    <div className="App noselect">
      <div className="mainContainer">
        <div className="subContainer">
          <img className="mainFlowImg" src="/flowTimerEmpty.png" alt="Flow Timer" />
          <div className="flowTimerBox">
            <FlowTimer />
          </div>
         
        </div>
      </div>
    </div>
  );
}

export default App;
